// Pages
export const FEED_VIEW = 'FEED_VIEW';
export const INBOX_VIEW = 'INBOX_VIEW';
export const MATERIALS_VIEW = 'Material Viewed';
export const NOTIFICATIONS_VIEW = 'NOTIFICATIONS_VIEW';
export const SETTINGS_VIEW = 'SETTINGS_VIEW';
export const INVITE_VIEW = 'INVITE_STUDENTS_VIEW';
export const POST_VIEW = 'POST_VIEW';
export const LOGIN_VIEW = 'LOGIN_VIEW';
export const SUBMISSIONS_VIEW = 'SUBMISSIONS_VIEW';
export const ALL_IMPORTANT_POSTS_VIEW_FROM_SIDEBAR =
  'ALL_IMPORTANT_POSTS_VIEW_FROM_SIDEBAR';
export const IMPORTANT_POST_VIEW_FROM_SIDEBAR =
  'IMPORTANT_POST_VIEW_FROM_SIDEBAR';

// Onboarding
export const CODE_LOGIN = 'CODE_LOGIN';
export const LAUNCH_AULA = 'LAUNCH_AULA';
export const REQUEST_CODE_LOGIN = 'REQUEST_CODE_LOGIN';
export const INTENTIONAL_LOGIN = 'INTENTIONAL_LOGIN';
export const SIGNUP_CREATE = 'SIGNUP_CREATE';
export const SIGNUP_JOIN = 'SIGNUP_JOIN';
export const APP_LAUNCH = 'APP_LAUNCH';

// Interaction
export const POST_EDITOR_START = 'POST_EDITOR_START';
export const COMMENT_EDITOR_START = 'COMMENT_EDITOR_START';
export const INBOX_EDITOR_START = 'INBOX_EDITOR_START';
export const MATERIAL_EDITOR_START = 'MATERIAL_EDITOR_START';
export const MATERIAL_EDITOR_FIRST_EDIT = 'MATERIAL_EDITOR_FIRST_EDIT';
export const CHANGE_CLASSROOM = 'CHANGE_CLASSROOM';
export const SELECT_SPACE_STAFF_SPACE_SELECTOR =
  'SELECT_SPACE_STAFF_SPACE_SELECTOR';
export const SPACE_SELECTOR_CATEGORY_SELECTED =
  'SPACE_SELECTOR_CATEGORY_SELECTED';
export const SPACE_SELECTOR_SUB_CATEGORY_SELECTED =
  'SPACE_SELECTOR_SUB_CATEGORY_SELECTED';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const REMOVE_PARTICIPANT_CLICKED = 'REMOVE_PARTICIPANT_CLICKED';
export const REMOVE_PARTICIPANT_CONFIRMED = 'REMOVE_PARTICIPANT_CONFIRMED';
export const LEAVE_SPACE_CLICKED = 'LEAVE_SPACE_CLICKED';
export const LEAVE_SPACE_CONFIRMED = 'LEAVE_SPACE_CONFIRMED';
export const PROMOTE_PARTICIPANT = 'PROMOTE_PARTICIPANT';
export const UNPROMOTE_PARTICIPANT = 'UNPROMOTE_PARTICIPANT';
export const JOIN_CLASSROOM = 'JOIN_CLASSROOM';
export const CREATE_CLASSROOM = 'CREATE_CLASSROOM';
export const CLICK_TAG = 'CLICK_TAG';
export const USER_CHANGE_AVATAR = 'USER_CHANGE_AVATAR';
export const USER_CHANGE_STATUS = 'USER_CHANGE_STATUS';
export const CONVERSATION_VIEW = 'CONVERSATION_VIEW';
export const OMNISEARCH_OPEN_MODAL = 'OMNISEARCH_OPEN_MODAL';
export const OMNISEARCH_QUERY = 'OMNISEARCH_QUERY';
export const SCREEN_READER_ENABLED = 'SCREEN_READER_ENABLED';
export const LOAD_MORE_COMMENTS = 'LOAD_MORE_COMMENTS';
export const ADD_DISCUSSION = 'ADD_DISCUSSION';
export const REMOVE_DISCUSSION = 'REMOVE_DISCUSSION';
export const HIDE_DISCUSSION = 'HIDE_DISCUSSION';
export const SHOW_DISCUSSION = 'SHOW_DISCUSSION';
export const JUMP_TO_DISCUSSION = 'JUMP_TO_DISCUSSION';
export const SEARCH_INBOX_DM = 'SEARCH_INBOX_DM';
export const CANCEL_GROUP_CREATE = 'CANCEL_GROUP_CREATE';
export const ADD_EDUCATOR_CLICKED = 'ADD_EDUCATOR_CLICKED';
export const ADD_EDUCATOR_SUBMIT_CLICKED = 'ADD_EDUCATOR_SUBMIT_CLICKED';
export const PARTICIPANTS_SORT_CHANGED = 'PARTICIPANTS_SORT_CHANGED';
export const PARTICIPANT_HISTORY_OPENED = 'PARTICIPANT_HISTORY_OPENED';

/* Pinned posts */
export const MAKE_IMPORTANT = 'MAKE_IMPORTANT';
export const MAKE_NOT_IMPORTANT = 'MAKE_NOT_IMPORTANT';

export const CLASSROOM_CHANGE_AVATAR = 'CLASSROOM_CHANGE_AVATAR';
export const EMAIL_INVITE = 'EMAIL_INVITE';

// My Assignment
export const FETCH_ASSIGNMENTS = 'FETCH_ASSIGNMENTS';
export const CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT';
export const CONVERT_ASSIGNMENT = 'CONVERT_ASSIGNMENT';
export const EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT';
export const CLOSE_ASSIGNMENT = 'CLOSE_ASSIGNMENT';
export const REOPEN_ASSIGNMENT = 'REOPEN_ASSIGNMENT';
export const DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT';
export const EXPORT_ASSIGNMENT_GRADES = 'EXPORT_ASSIGNMENT_GRADES';
export const BULK_DOWNLOAD = 'BULK_DOWNLOAD';

// Engagement
export const CLICK_ENGAGEMENT_STUDENT_TAB = 'CLICK_ENGAGEMENT_STUDENT_TAB';

// Submissions
export const FILTER_SUBMISSIONS_BY_GROUP_ID = 'FILTER_SUBMISSIONS_BY_GROUP_ID';
export const VIEW_STUDENT_SUBMISSION = 'VIEW_STUDENT_SUBMISSION';
export const DELETE_SUBMISSION = 'DELETE_SUBMISSION';

// Groups settings
export const EXPORT_GROUP_SET_PARTICIPANTS = 'EXPORT_GROUP_SET_PARTICIPANTS';
export const CREATE_GROUPS_VIA_CSV_UPLOAD = 'CREATE_GROUPS_VIA_CSV_UPLOAD';

// NOTIFICATIONS
export const CLICK_LOCAL_NOTIFICATION = 'CLICK_LOCAL_NOTIFICATION';
export const CLICK_PUSH_NOTIFICATION = 'CLICK_PUSH_NOTIFICATION';

// SPACE SELECTOR
export const SPACE_SELECTOR_DISMISSED = 'SPACE_SELECTOR_DISMISSED';
export const SPACE_SELECTOR_SPACE_SELECTED = 'SPACE_SELECTOR_SPACE_SELECTED';
export const SPACE_SELECTOR_ARCHIVED_TOGGLE = 'SPACE_SELECTOR_ARCHIVED_TOGGLE';
export const SPACE_SELECTOR_SEARCH = 'SPACE_SELECTOR_SEARCH';
export const SPACE_SELECTOR_SORT = 'SPACE_SELECTOR_SORT';
export const SPACE_SELECTOR_SPACE_STARRED = 'SPACE_SELECTOR_SPACE_STARRED';
export const SPACE_SELECTOR_SPACE_UNSTARRED = 'SPACE_SELECTOR_SPACE_UNSTARRED';

// MATERIALS
export const MATERIALS_TAB_VIEW = 'MATERIALS_TAB_VIEW';
export const MATERIALS_RBAC_PERMISSIONS_LINK_CLICKED =
  'MATERIALS_RBAC_PERMISSIONS_LINK_CLICKED';
export const MATERIALS_PERMISSION_DENIED = 'MATERIALS_PERMISSION_DENIED';

// ITEM TYPES
export const SPACE_SELECTOR_ITEM_TYPE = 'spaceSelector';
export const ASSIGNMENT_ITEM_TYPE = 'Assignment';
export const MATERIAL_ITEM_TYPE = 'Material';
export const INBOX_MESSAGE_ITEM_TYPE = 'UBInboxMessage';
export const COMMENT_ITEM_TYPE = 'UBComment';
export const HOME_WIDGET_ITEM_TYPE = 'home_widget';
export const HOME_PAGE_ITEM_TYPE = 'home';

// NAVIGATION SOURCES
export const NAVIGATION_SOURCE_RECENTLY_VIEWED_SPACES =
  'recently_viewed_spaces';
export const NAVIGATION_SOURCE_STARRED_SPACES = 'starred_spaces';
export const NAVIGATION_SOURCE_UPCOMING_ASSIGNMENTS = 'upcoming_assignments';
export const NAVIGATION_SOURCE_MESSAGES = 'messages';
export const NAVIGATION_SOURCE_QUICK_LINKS = 'quick_links';

// WIDGET IDS
export const WIDGET_ID_STARRED_SPACES = 'home-starred-spaces-widget';
export const WIDGET_ID_RECENTLY_VIEWED_SPACES =
  'home-recently-viewed-spaces-widget';
export const WIDGET_ID_UPCOMING_ASSIGNMENTS =
  'home-upcoming-assignments-widget';
export const WIDGET_ID_MESSAGES = 'home-messages-widget';
export const WIDGET_ID_QUICK_LINKS = 'home-quick-links-widget';

// VISIBLE LEARNING
export const VIEW_PROGRESS_OVERVIEW = 'VIEW_PROGRESS_OVERVIEW';

// LTI
export const LTI_BLOCK_LAUNCH = 'LTI_BLOCK_LAUNCH';

// STAR UNSTAR SPACES:EEVENTS
export const SPACE_STARRED = 'space_starred';
export const SPACE_UNSTARRED = 'space_unstarred';
export const STAR_UNSTAR_MY_SPACE_PAGE_REMAINING = 'my_space_page_remaining';
export const STAR_UNSTAR_MENU = 'menu';
export const MY_SPACE_PAGE_RECENTLY_VIEWED_SECTION =
  'my_space_page_recently_viewed_section';
export const MY_SPACE_PAGE_SEARCH_RESULT = 'my_space_page_search_result';

// STAR UNSTAR SPACES: ANALYTICS KEYS
export const TOTAL_STARRED_SPACES_AFTER_ACTION_KEY =
  'total_starred_spaces_after_action';

// MY SPACES
export const MY_SPACES_PAGE_VIEW = 'my_spaces_page_view';
export const RECENTLY_VIEWED_CLICKED_FROM_MY_SPACES =
  'recently_viewed_clicked_from_my_spaces';

// HOME TOUR
export const HOME_TOUR_PROMPT_SHOWN = 'HOME_TOUR_PROMPT_SHOWN';
export const HOME_TOUR_DISMISSED = 'HOME_TOUR_DISMISSED';
export const HOME_TOUR_STARTED = 'HOME_TOUR_STARTED';
export const HOME_TOUR_STEP_VIEWED = 'HOME_TOUR_STEP_VIEWED';
export const HOME_TOUR_COMPLETED = 'HOME_TOUR_COMPLETED';
export const HOME_TOUR_SKIPPED = 'HOME_TOUR_SKIPPED';

// MESSAGES
export const MESSAGE_CONVERSATION_OPENED = 'MESSAGE_CONVERSATION_OPENED';
export const MESSAGE_ARCHIVE_VIEWED = 'MESSAGE_ARCHIVE_VIEWED';
export const MESSAGE_NEW_INITIATED = 'MESSAGE_NEW_INITIATED';
export const MESSAGE_CONVERSATION_CREATED = 'MESSAGE_CONVERSATION_CREATED';
export const MESSAGE_MUTED = 'MESSAGE_MUTED';
export const MESSAGE_LEFT = 'MESSAGE_LEFT';
export const MESSAGE_ARCHIVED = 'MESSAGE_ARCHIVED';
export const MESSAGE_PARTICIPANTS_VIEWED = 'MESSAGE_PARTICIPANTS_VIEWED';
export const MESSAGE_PARTICIPANT_INVITED = 'MESSAGE_PARTICIPANT_INVITED';
export const MESSAGE_PARTICIPANT_REMOVED = 'MESSAGE_PARTICIPANT_REMOVED';
export const MESSAGE_REPLIED = 'MESSAGE_REPLIED';
export const MESSAGE_SENT = 'MESSAGE_SENT';
export const MESSAGE_EDITED = 'MESSAGE_EDITED';
export const MESSAGE_REACTION_ADDED = 'MESSAGE_REACTION_ADDED';
export const MESSAGE_FILE_UPLOADED = 'MESSAGE_FILE_UPLOADED';
export const MESSAGE_CODE_FORMAT_USED = 'MESSAGE_CODE_FORMAT_USED';
export const MESSAGES_NAV_OPENED = 'MESSAGES_NAV_OPENED';
export const MESSAGES_PAGE_VIEWED = 'MESSAGES_PAGE_VIEWED';
export const MESSAGES_INBOX_LOADED = 'MESSAGES_INBOX_LOADED';
export const MESSAGES_EMPTY_STATE_VIEWED = 'MESSAGES_EMPTY_STATE_VIEWED';
// Participants
export const PARTICIPANTS_TILE_CLICKED = 'PARTICIPANTS_TILE_CLICKED';
export const PARTICIPANT_DOWNLOAD_CLICKED = 'PARTICIPANT_DOWNLOAD_CLICKED';
// Groups
export const GROUPS_PAGE_VIEW = 'GROUPS_PAGE_VIEW';
export const GROUP_PARTICIPANT_SEARCH = 'GROUP_PARTICIPANT_SEARCH';
export const CANCEL_GROUP_SET_CREATE = 'CANCEL_GROUP_SET_CREATE';
export const OPEN_GROUP_SET_CREATE_MODAL = 'OPEN_GROUP_SET_CREATE_MODAL';
export const OPEN_GROUP_CREATE_MODAL = 'OPEN_GROUP_CREATE_MODAL';
export const GROUPS_CSV_UPLOAD_FAILED = 'GROUPS_CSV_UPLOAD_FAILED';

// Home
// HOME PAGE VIEWED
export const HOME_PAGE_VIEWED = 'HOME_PAGE_VIEWED';
// HOME PAGE WIDGETS
export const HOME_VIEW_ALL_CLICKED = 'HOME_VIEW_ALL_CLICKED';
export const HOME_WIDGET_HIDDEN = 'HOME_WIDGET_HIDDEN';
export const HOME_WIDGET_UNHIDDEN = 'HOME_WIDGET_UNHIDDEN';
